import React from "react";

export default ({loadMoreMessage}) => (
    <div className="small-button" style={{ height: "auto", textAlign: "center", marginBottom: "10px" }}>
        <button onClick={() => loadMoreMessage()}>Загрузить еще</button>
    </div>
)


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Chat/MoreButon.js